import { render } from "./modalRegistrarNovedades.vue?vue&type=template&id=6a2ce0f1&scoped=true"
import script from "./modalRegistrarNovedades.vue?vue&type=script&lang=js"
export * from "./modalRegistrarNovedades.vue?vue&type=script&lang=js"

import "./modalRegistrarNovedades.vue?vue&type=style&index=0&id=6a2ce0f1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2ce0f1"]])

export default __exports__